module.exports = __webpack_public_path__ + "img/pan.be5030ca.webp";